/**
 * Transform relative media URLs to full URLs using the API base URL
 * @param url - The URL to transform (can be relative or absolute)
 * @returns Full URL with base URL prepended if needed
 */
export const getFullMediaUrl = (url: string | undefined | null): string | null => {
  if (!url) return null;

  // If already a full URL, return as-is
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }

  // Build full URL from relative path
  const baseUrl = process.env.REACT_APP_API_URL?.replace('/api/v1', '') || 'http://localhost:8080';
  return `${baseUrl}${url}`;
};
